/**
 * Used to position the scroll position in the chat to it if present.
 */
export const NEW_MESSAGES_BANNER_ID = '_nmbi';
